import { useNavigate } from "react-router-dom";

import { useActiveUsersOnly } from "useAuth";

import { Box, Link } from "@mui/material";
import { useAppContext } from "../../../app/AppContext";
import Typography from '@mui/material/Typography';
import Logo2 from "../../../assets/images/logo2.png";
import AddVisitaIcon from "./AddVisitaIcon.png";
import Background from "./Background.jpeg";
import SearchVisitaIcon from "./SearchVisitaIcon.png";


export default function Home() {
    useActiveUsersOnly()
    const navigate = useNavigate();
    const { useSetTitle } = useAppContext();
    useSetTitle("Início");

    return (
        <Box
            sx={{
                display: "flex",
                flex: 1,
                backgroundImage: `url(${Background})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    backgroundColor: "rgba(255, 255, 255, 20%)",
                }}
            >
                <img
                    src={Logo2}
                    alt="Logotipo da empresa TCH Gestão Agrícola"
                    style={{ width: "100%", maxWidth: "250px" }}
                />
                <Link sx={{ position: "fixed", bottom: "20px", left: "20px" }} onClick={() => navigate("/visita")}>
                    <img src={AddVisitaIcon} width="75px" alt="Criar Laudo" />
                </Link>

                <Link sx={{ position: "fixed", bottom: "20px", right: "20px" }} onClick={() => navigate("/ConsultaVisitasRelatorios")}>
                    <img src={SearchVisitaIcon} width="75px" alt="Buscar Laudo" />
                </Link>
            </Box>

            <Typography
                nowrap="true"
                component="div"
                sx={{
                    fontWeight: 900,
                    backdropFilter: 'blur(3px)',
                    padding: "5px",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    margin: "5px",
                    fontSize: 14
                }}
            >
                {process.env.REACT_APP_VERSION}
            </Typography>
        </Box >
    );
}
